module.exports = __webpack_public_path__ + "img/arrow-down.86d05ada.svg";